import PropTypes from 'prop-types';
import MUISwitch from '@material-ui/core/Switch';

const Switch = props => {
  const { onChange, checked, color, disabled } = props;

  return (
    <MUISwitch
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      color={color}
    />
  );
};

Switch.defaultProps = {
  onChange: () => {},
  color: 'primary',
};

Switch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  color: PropTypes.string,
};

export default Switch;
